"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "BubblyError___StyledSvg",
  componentId: "sc-1ctpwk3-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function BubblyError(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    viewBox: "0 0 150 150",
    width: "1em",
    height: "1em",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#F2F2F2"
  }), _react["default"].createElement("use", {
    fill: "#E9E9E9"
  }), _react["default"].createElement("g", {
    transform: "translate(27 34)"
  }, _react["default"].createElement("path", {
    d: "M97 40.559C97 18.159 75.286 0 48.5 0S0 18.159 0 40.559s21.714 40.559 48.5 40.559c8.04 0 15.623-1.636 22.299-4.532 2.257 1.819 6.273 3.87 13.415 5.414-2.86-5.048-3.474-8.748-3.138-11.392C90.858 63.188 97 52.473 97 40.558zM86.824 80.521c1.278 2.254-.711 4.959-3.244 4.411-5.782-1.25-10.108-2.92-13.178-4.932-6.789 2.698-14.228 4.118-21.902 4.118C20.164 84.118-3 64.746-3 40.56S20.164-3 48.5-3 100 16.372 100 40.56c0 12.142-5.89 23.443-16.008 31.576.039 2.198.896 4.97 2.831 8.385z",
    fill: "#2666AB",
    fillRule: "nonzero"
  }), _react["default"].createElement("path", {
    d: "M81.076 70.608C90.857 63.188 97 52.473 97 40.559 97 18.159 75.286 0 48.5 0S0 18.159 0 40.559s21.714 40.559 48.5 40.559c8.04 0 15.623-1.636 22.299-4.532 2.257 1.819 6.273 3.87 13.415 5.414-2.86-5.048-3.474-8.748-3.138-11.392z",
    fill: "#6DA9E9"
  }), _react["default"].createElement("path", {
    d: "M27.5 29a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: "#2666AB"
  }), _react["default"].createElement("circle", {
    cx: 54.5,
    cy: 24.5,
    r: 4.5,
    fill: "#2666AB"
  }), _react["default"].createElement("path", {
    d: "M64.907 81.843a54.362 54.362 0 001.89-.653 50.832 50.832 0 004.141-1.715c1.871-.882 3.422-1.789 4.562-2.732a1.5 1.5 0 00-1.913-2.311c-.911.754-2.264 1.545-3.928 2.33a47.932 47.932 0 01-3.894 1.612 51.363 51.363 0 01-1.757.607 1.5 1.5 0 10.9 2.862z",
    fill: "#2666AB",
    fillRule: "nonzero"
  })), _react["default"].createElement("path", {
    d: "M81.99 84.628C81.298 77.54 75.298 72 67.999 72c-7.287 0-13.279 5.521-13.988 12.592-.046.463 0 1.408 1.342 1.408H80.65c1.339 0 1.383-.92 1.339-1.372zM67.999 69c8.796 0 16.13 6.665 16.977 15.337.232 2.373-1.15 4.663-4.325 4.663H55.353c-3.197 0-4.566-2.32-4.327-4.707C51.894 75.641 59.22 69 68 69z",
    fill: "#2666AB",
    fillRule: "nonzero"
  }), _react["default"].createElement("path", {
    d: "M54.01 84.628C54.702 77.54 60.702 72 68.001 72c7.287 0 13.279 5.522 13.988 12.592.046.463 0 1.408-1.342 1.408H55.35c-1.339 0-1.383-.92-1.339-1.372z",
    fill: "#fff"
  }), _react["default"].createElement("path", {
    d: "M57.147 46.853a1.5 1.5 0 00-1.294-2.706l-11.5 5.5a1.5 1.5 0 001.294 2.706l11.5-5.5z",
    fill: "#2666AB",
    fillRule: "nonzero"
  }), _react["default"].createElement("circle", {
    cx: 40.5,
    cy: 72.5,
    r: 7.5,
    fill: "#A263EB"
  }), _react["default"].createElement("path", {
    d: "M81.147 44.147a1.5 1.5 0 10-1.294 2.706l11.5 5.5a1.5 1.5 0 101.294-2.706l-11.5-5.5z",
    fill: "#2666AB",
    fillRule: "nonzero"
  }), _react["default"].createElement("circle", {
    cx: 95.5,
    cy: 72.5,
    r: 7.5,
    fill: "#A263EB"
  })));
}

var _default = BubblyError;
exports["default"] = _default;